import './App.scss';
import Landing from './components/landing/Landing.js';
import { BrowserRouter as Router, Switch, Route } from 'react-router-dom';
import Footer from './components/landing/footer/Footer.js';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import SimpleProposal from './components/submitPorposal/SimpleProposal';
import AddFund from './components/submitPorposal/AddFund';
import AddContraction from './components/submitPorposal/AddContraction';
import ArtDaoProposal from './components/submitPorposal/ArtDaoProposal';
import Executed from './components/buttonComponent/Executed';


function App() {
  return (
    <>
        <ToastContainer style={{ fontSize: 20 }} />
          <Router>
            {/* <Navbar/> */}
            <Switch>
              <Route exact path='/' component={Landing} />
              <Route exact path='/simpleproposal' component={SimpleProposal} />
              <Route exact path='/addfund' component={AddFund} />
              <Route exact path='/addcontraction' component={AddContraction} />
              <Route exact path='/artdaoproposal' component={ArtDaoProposal} />
              <Route exact path='/executed' component={Executed} />
            </Switch>
            <Footer/>
          </Router>
    </>
  );
}

export default App;
